<template>
  <div class="year-selector">
    <div class="content-wrap">
      <h2 class="title">
        <span>📘 اختبر نفسك</span>
      </h2>

      <div class="years-grid">
        <button
          v-for="year in options"
          :key="year"
          :disabled="isLocked(year)"
          @click="select(year)"
          :class="['year-button', { locked: isLocked(year) }]"
          type="button"
        >
          <span class="year-content">
            <span class="year-text">{{ bankLabel(year) }}</span>
            <span v-if="isLocked(year)" class="lock-icon">🔒</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YearSelector',

  props: {
    options: {
      type: Array,
      required: true
    },
    type: { // B / w / M / D / T
      type: String,
      required: true
    },
    activated: {
      type: Boolean,
      default: false
    },
    lockedYears: {
      type: Array,
      default: () => []
    }
  },

  emits: ['select'],

  methods: {
    select(year) {
      if (!this.isLocked(year)) {
        this.$emit('select', year);
      }
    },

    isLocked(year) {
      const y = Number(year);
      return this.lockedYears.includes(y) && !this.activated;
    },

    bankLabel(year) {
      const y = Number(year);

      const labelsB = {
        1: 'بنك الأزمنة 1',
        2: 'بنك الأزمنة 2',
        3: 'بنك الأزمنة 3',
        4: 'بنك الأزمنة 4',
        5: 'بنك الأزمنة 5',
        6: 'حروف الجر',
        7: 'الأفعال المركبة',
        8: 'الأسماء الموصولة',
        9: 'محددات الكمية',
        10: 'الأفعال المساعدة الناقصة',
        11: 'أدوات الربط',
        12: 'اللواحق للكلمات',
        13: 'استخدام اللغة',
        14: 'اختر القسم الخاطئ',
        15: 'اختر الجملة الخطأ',
        16: 'اختر الجملة الصح',
        17: 'مفردات',
        18: 'مفردات',
        19: 'مفردات',
        20: 'مفردات',
        21: 'مفردات',
        22: 'مرادفات',
        23: 'بنك شامل نماذج امتحانية'
      };

      const labelsD = {
        1: 'بنك الأزمنة 1',
        2: 'بنك الأزمنة 2',
        3: 'بنك الأزمنة 3',
        4: 'بنك الأزمنة 4',
        5: 'بنك الأزمنة 5',
        6: 'حروف الجر',
        7: 'الأفعال المركبة',
        8: 'الأسماء الموصولة',
        9: 'محددات الكمية',
        10: 'الأفعال المساعدة الناقصة',
        11: 'أدوات الربط',
        12: 'اللواحق للكلمات',
        13: 'استخدام اللغة'
      };

      const labelsT = {
        1: 'بنك الأزمنة 1',
        2: 'بنك الأزمنة 2',
        3: 'بنك الأزمنة 3',
        4: 'بنك الأزمنة 4',
        5: 'بنك الأزمنة 5',
        6: 'حروف الجر',
        7: 'الأفعال المركبة',
        8: 'الأسماء الموصولة',
        9: 'محددات الكمية',
        10: 'الأفعال المساعدة الناقصة',
        11: 'أدوات الربط',
        12: 'اللواحق للكلمات',
        13: 'استخدام اللغة',
        14: 'اختر القسم الخاطئ',
        15: 'اختر الجملة الخطأ',
        16: 'اختر الجملة الصح',
        17: 'مفردات',
        18: 'مفردات',
        19: 'مفردات',
        20: 'مفردات',
        21: 'مفردات',
        22: 'مرادفات',
        23: 'بنك شامل نماذج امتحانية'
      };

      const labelsW = {
        1: 'بنك الأزمنة 1',
        2: 'بنك الأزمنة 2',
        3: 'بنك الأزمنة 3',
        4: 'بنك الأزمنة 4',
        5: 'بنك الأزمنة 5',
        6: 'حروف الجر',
        7: 'الأفعال المركبة',
        8: 'الأسماء الموصولة',
        9: 'محددات الكمية',
        10: 'الأفعال المساعدة الناقصة',
        11: 'أدوات الربط',
        12: 'اللواحق للكلمات',
        13: 'استخدام اللغة',
        14: 'اختر القسم الخاطئ',
        15: 'اختر الجملة الخطأ',
        16: 'اختر الجملة الصح'
      };

      const labelsM = {
        1: 'بنك الأزمنة 1',
        2: 'بنك الأزمنة 2',
        3: 'بنك الأزمنة 3',
        4: 'بنك الأزمنة 4',
        5: 'بنك الأزمنة 5',
        6: 'حروف الجر',
        7: 'الأفعال المركبة',
        8: 'الأسماء الموصولة',
        9: 'محددات الكمية',
        10: 'الأفعال المساعدة الناقصة',
        11: 'أدوات الربط',
        12: 'اللواحق للكلمات',
        13: 'استخدام اللغة',
        14: 'اختر القسم الخاطئ',
        15: 'اختر الجملة الخطأ',
        16: 'اختر الجملة الصح'
      };

      const maps = { B: labelsB, D: labelsD, w: labelsW, M: labelsM, T: labelsT };
      const selectedMap = maps[this.type] || {};

      return selectedMap[y] || `البنك رقم ${y}`;
    }
  }
};
</script>





<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@400;600;800;900&display=swap');

:root {
  --gold-25: rgba(212, 175, 55, 0.25);
  --gold-35: rgba(212, 175, 55, 0.35);
  --gold: #e8c55a;
  --gold-deep: #c9a63a;

  --bg-0: #000;          /* خلفية عميقة */
  --bg-1: #0a0a0a;       /* تدرّج خفيف */
  --glass: rgba(24, 24, 28, 0.55);

  --text: #f5f5f7;
  --text-dim: #b7b7bf;

  --rad-xl: 22px;
  --rad-lg: 16px;

  --t: 260ms cubic-bezier(.25,.8,.25,1);
}

/* منع أي تمرير أفقي */
:host, .year-selector {
  overflow-x: hidden;
  direction: rtl;
}

/* الحاوية العامة */
.year-selector {
  min-height: 100vh;
  width: 100%;
  display: grid;
  place-items: center;
  background: radial-gradient(1200px 600px at 50% -10%, rgba(255,255,255,0.05), transparent 60%),
              linear-gradient(180deg, var(--bg-0), var(--bg-1) 60%, var(--bg-0));
  color: var(--text);
  font-family: 'Tajawal', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  -webkit-tap-highlight-color: transparent;
}

/* التفاف المحتوى لضمان اتساق الهوامش والحد الأقصى للعرض */
.content-wrap {
  width: min(92vw, 880px);
  margin: 0 auto;
  padding: clamp(12px, 2vw, 20px);
  display: grid;
  gap: clamp(12px, 2.5vw, 18px);
}

/* العنوان */
.title {
  text-align: center;
  margin: 0;
  font-weight: 800;
  letter-spacing: 0.2px;
  font-size: clamp(1.2rem, 3.8vw, 1.8rem);
  line-height: 1.25;
  color: #fff;
  text-shadow:
    0 2px 6px rgba(0,0,0,0.55),
    0 0 1px rgba(255,255,255,0.25);
}

/* لوحة السنوات (زجاجي فاخر) */
.years-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: clamp(10px, 2.2vw, 16px);
  width: 100%;
  padding: clamp(12px, 2.6vw, 18px);
  border-radius: var(--rad-xl);

  background: linear-gradient(180deg, rgba(18,18,20,0.7), rgba(16,16,18,0.52));
  border: 1px solid var(--gold-35);
  outline: 1px solid rgba(255,255,255,0.04); /* لمعان خفيف للحافة */
  backdrop-filter: blur(16px) saturate(160%);
  -webkit-backdrop-filter: blur(16px) saturate(160%);
  box-shadow:
    0 10px 28px rgba(0,0,0,0.65),
    0 0 22px var(--gold-25);
}

/* زر سنة */
.year-button {
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: var(--rad-lg);
  padding: clamp(10px, 2.2vw, 14px) clamp(12px, 2.4vw, 16px);
  font-size: clamp(0.95rem, 2.4vw, 1.05rem);
  font-weight: 700;
  color: var(--text);
  background:
    linear-gradient(180deg, rgba(38,38,42,0.6), rgba(16,16,18,0.7)),
    radial-gradient(120% 150% at 20% 0%, rgba(232,197,90,0.06), transparent 60%);
  cursor: pointer;
  transition: transform var(--t), box-shadow var(--t), color var(--t), background var(--t), border-color var(--t);
  position: relative;
  overflow: hidden;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  box-shadow:
    0 6px 14px rgba(0,0,0,0.5),
    inset 0 0 0 0 rgba(232,197,90,0);
}

/* لمعان مائل رقيق */
.year-button::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(115deg, transparent 35%, rgba(255,255,255,0.12) 50%, transparent 65%);
  transform: translateX(-140%);
  transition: transform 900ms ease;
  pointer-events: none;
}

.year-button:hover::after {
  transform: translateX(140%);
}

.year-button:hover {
  transform: translateY(-2px);
  color: var(--gold);
  border-color: rgba(232,197,90,0.35);
  box-shadow:
    0 10px 22px rgba(0,0,0,0.55),
    inset 0 0 10px rgba(232,197,90,0.14);
}

.year-button:active {
  transform: translateY(0);
  box-shadow:
    0 6px 12px rgba(0,0,0,0.45),
    inset 0 0 6px rgba(232,197,90,0.12);
  filter: brightness(0.98);
}

.year-button:focus-visible {
  outline: none;
  box-shadow:
    0 0 0 3px rgba(232,197,90,0.28),
    0 8px 18px rgba(0,0,0,0.5);
}

/* محتوى النص داخل الزر */
.year-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.year-text {
  overflow: hidden;
  text-overflow: ellipsis;
}

/* زر مقفول */
.year-button.locked {
  background: linear-gradient(180deg, #2b2b2f, #1c1c20);
  color: #9b9ba3;
  cursor: not-allowed;
  border-color: rgba(255,255,255,0.06);
  box-shadow: none;
}

.year-button.locked .lock-icon {
  margin-inline-start: 0.35rem;
  font-size: 1.05rem;
}

/* تحسينات للموبايل الصغيرة جداً */
@media (max-width: 420px) {
  .years-grid {
    grid-template-columns: 1fr;
    padding: 12px;
    gap: 10px;
  }
  .year-button {
    font-size: 1rem;
  }
}

/* تحسينات للشاشات المتوسطة */
@media (min-width: 768px) {
  .years-grid {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  }
}

/* تقليل احتمال ظهور شريط تمرير أفقي بسبب الظلال */
* {
  box-sizing: border-box;
}

/* معالجة آمنة للـ viewport على الأجهزة ذات القضبان/الشقوق */
.year-selector {
  padding: max(12px, env(safe-area-inset-top)) max(12px, env(safe-area-inset-inline-start)) max(16px, env(safe-area-inset-bottom)) max(12px, env(safe-area-inset-inline-end));
}
</style>